<template>
  <div data-v-f531b812="" class="app app-ti_green metransRecord pay-info-page">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <span class="pay-back">
                <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
              </span>
            </div>
            <div class="van-nav-bar__title van-ellipsis">{{ isKbzPending ? 'KBZ收银台' : '充值信息' }}</div>
            <!-- <div class="van-nav-bar__right" @click="$parent.openKefu">
              <div class="header-style-icon"><img src="/static/image/kefuIcon.9bf50982.png" /></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  <div style="height:40px"></div>
    <div data-v-334775a8="" data-v-f531b812="" class="wrapper green-wrapper">
      <div data-v-334775a8="">
        <div data-v-334775a8="" class="PayInfoTime green-PayInfoTime">
          <div class="PayAmount">
            <span class="Amount">{{ payInfo.info.amount }}</span
            ><span> Ks </span>
          </div>
          <div class="Countdown">
            <div>
              请在<span place="time">{{ m >= 10 ? m : `0${m}` }}：{{ s >= 10 ? s : `0${s}` }}</span
              >内完成支付
            </div>
          </div>
          <div>{{ isKbzPending ? '转账成功后请填写账单后四位并提交审核' : '成功付款后，将自动到账！' }}</div>
          <div>如有问题，请<span place="thing" class="contact-customer" @click="$parent.openKefu"> 联系客服 </span>确认</div>
        </div>
      </div>

      <div data-v-334775a8="" class="transaction-detail bg">
        <template v-if="type == 'bankpay' && payInfo.cardlist">
          <p data-v-334775a8="">请按下方账户转账，转账后等待后台审核</p>
          <p data-v-334775a8="">
            <span data-v-334775a8=""> 收款银行 </span>
            <span data-v-334775a8=""><span class="transNum paddingSty">{{ payInfo.cardlist.bank_name }}</span></span>
          </p>
          <p data-v-334775a8="">
            <span data-v-334775a8=""> 收款账号 </span>
            <span data-v-334775a8="">
              <span class="transNum paddingSty">{{ payInfo.cardlist.bank_no }}</span>
              <span class="copy" @click="doCopy(payInfo.cardlist.bank_no)"> 复制 </span>
            </span>
          </p>
          <p data-v-334775a8="">
            <span data-v-334775a8=""> 收款人 </span>
            <span data-v-334775a8="">
              <span class="transNum paddingSty">{{ payInfo.cardlist.bank_owner }}</span>
              <span class="copy" @click="doCopy(payInfo.cardlist.bank_owner)"> 复制 </span>
            </span>
          </p>
          <p data-v-334775a8="" v-if="payInfo.cardlist.bank_address">
            <span data-v-334775a8=""> 开户行 </span>
            <span data-v-334775a8="">
              <span class="transNum paddingSty">{{ payInfo.cardlist.bank_address }}</span>
              <span class="copy" @click="doCopy(payInfo.cardlist.bank_address)"> 复制 </span>
            </span>
          </p>
        </template>
        <p data-v-334775a8="" v-if="type == 'usdtpay'">
          <span data-v-334775a8=""> 收款地址 </span
          ><span data-v-334775a8="" style="word-break: break-word; max-width: 240px"
            ><span data-v-334775a8="" class="transNum paddingSty">{{ payInfo.cardlist.mch_id }}</span
            ><span @click="doCopy(payInfo.cardlist.mch_id)" data-v-334775a8="" class="copy"> 复制 </span></span
          >
        </p>
        <template v-if="type == 'kbzpay'">
          <p data-v-334775a8="">请按下方KBZ账号转账，转账成功后填写账单后四位提交审核</p>
          <p data-v-334775a8="">
            <span data-v-334775a8=""> KBZ账号 </span>
            <span data-v-334775a8="">
              <span class="transNum paddingSty">{{ kbzDisplayPhone }}</span>
              <span class="copy copy-strong" @click="doCopy(kbzDisplayPhone)">复制</span>
            </span>
          </p>
          <p data-v-334775a8="" v-if="kbzDisplayName">
            <span data-v-334775a8=""> 收款人 </span>
            <span data-v-334775a8="">
              <span class="transNum paddingSty">{{ kbzDisplayName }}</span>
              <span class="copy copy-strong" @click="doCopy(kbzDisplayName)">复制</span>
            </span>
          </p>
        </template>

        <p data-v-334775a8="" v-if="payInfo.deposit_no">
          <span data-v-334775a8=""> 订单号 </span
          ><span data-v-334775a8=""
            ><span data-v-334775a8="" class="transNum paddingSty">{{ payInfo.deposit_no }}</span
            ><span v-if="false" data-v-334775a8="" class="copy"> 复制 </span></span
          >
        </p>
        <p data-v-334775a8="">交易时间 <span data-v-334775a8="" class="tran-time"> {{ payInfo.info.created_at }} </span></p>
        <p data-v-334775a8="">
          充值方式<span data-v-334775a8="" class="tran-type">{{ payInfo.info.paytype }}</span>
        </p>
            <p data-v-334775a8="" v-if="type =='usdtpay'">
          钱包协议<span data-v-334775a8="" class="tran-type">{{ payInfo.cardlist.content }}</span>
        </p>
        <img v-if="qrUrl" class="pay-qr" :src="qrUrl" alt="支付二维码" />
        <button v-if="qrUrl" type="button" class="save-qr-btn" @click="saveQr">保存二维码</button>
        <div v-if="isKbzPending" class="kbz-complete">
          <div class="bill-last4">
            <span>账单后四位</span>
            <input
              ref="billInput"
              v-model="billLast4"
              type="text"
              maxlength="4"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="off"
              placeholder="请输入转账账单后四位"
              @focus="onBillFocus"
            />
          </div>
          <button type="button" class="complete-transfer-btn" :disabled="!canCompleteKbz" @click="completeKbzTransfer">完成转账</button>
        </div>
      </div>
      <div data-v-334775a8="" class="footer" v-if="!isKbzPending">
        <div data-v-334775a8="" class="goback-button" @click="$parent.goNav('/transRecord')">
          <img
            data-v-334775a8=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAPFBMVEVHcEwLqoUPqIUPqIYIp4cAr4AOqIYMp4cOp4UNp4UPqIYPqIYPqIYOp4YOqIUPqIYOqIUPp4UNqYYPqIanHmPRAAAAE3RSTlMAMO/wIBBwQIBg0MDfoLCvkOBQvn0j8QAAAJFJREFUGBl1wYkBwiAQBMAlPHdAXrf/XgVJFA3OoOMi/ogTBUM7yYABn1ko7szMSnETJ74ofu08beLQ8xs7c/C4mMRvs6AxE28ULwcHIirLkYgicmRyKMRyIKNyiQOCyi88LSJRV1YZTWCjqJxakg6NWFaKxiQy4OQSC8XJr1xx8QvJgIs/Mj4CafAmREce6MgTIHASgfcpjWAAAAAASUVORK5CYII="
            class="icon"
          /><span data-v-334775a8="">充值完成</span>
        </div>
        <div data-v-334775a8="" class="seedetail-button" @click="$parent.goNav('/transRecord')">
          <img
            data-v-334775a8=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAAOVBMVEUMqIcPqIYOqIUOqIYPqIUAr4ALqoVHcEwPp4YOqYcNp4UPqIYPp4UOqIYOqIUIp4cNqYYOqIUPqIbGVSZiAAAAEnRSTlM/0JBw8BAwAMB/YN/goG8gULADspVqAAAAtklEQVQoz42S2xbEEAxFg0hCbzP5/48d2lqL0mnPm2xHboDZL5NeZCwnAW+oA5mdfXX+wEURNWSmCtwpqiRGqj1iyFGAJxZDo1gzaYuUmllpZN/mo7Y9epvvHxvrmZ1v5oBfZZLgR4yOXSLxpYfkMooWHCr6Lp87HH5W2zFRe94xAxarmdGNT7o/UfKd/2VRXKHUyXudAXcD5LKLcn/llPy5JydYzcWl5YYt+QluZplem+8Ye6EfKyMbAQTPPjYAAAAASUVORK5CYII="
            class="icon"
          /><span data-v-334775a8="">资金明细</span>
        </div>
      </div>
      <!---->
    </div>

    <div data-v-f531b812="" class="float-divbox"></div>
    <span data-v-7b0f8a3e="" data-v-f531b812="" class="customer-service-container"></span><span data-v-f531b812=""></span>
    <div data-v-55ec3770="" data-v-f531b812="" class="select-service-line-view select-service-line-view">
      <dl data-v-55ec3770="" class="select-service-list"><div data-v-55ec3770="" style="height: 55px"></div></dl>
    </div>
  </div>
</template>
<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: { info: {}, cardlist: {} },
      type: null,
      daoTime: null,
      m: 0,
      s: 0,
      isKbzPending: false,
      kbzMethodId: '',
      kbzAmount: '',
      kbzPhone: '',
      kbzName: '',
      billLast4: '',
      submitting: false,
    };
  },
  created() {
    let that = this;

    var query = that.$route.query;
    if (query.kbz === '1' || query.kbz === 1) {
      that.initKbzPending(query);
      return;
    }
    if (query.deposit_no) {
      that.getpayinfo(query.deposit_no);
    }
  },
  methods: {
    saveQr() {
      const url = this.qrUrl;
      if (!url) {
        this.$parent.showTost(0, '暂无二维码');
        return;
      }
      fetch(url)
        .then(res => {
          if (!res.ok) throw new Error('download failed');
          return res.blob();
        })
        .then(blob => this.saveQrBlob(blob))
        .catch(() => {
          this.$parent.showTost(0, '保存失败，请稍后重试');
        });
    },
    saveQrBlob(blob) {
      const filename = 'pay-qrcode.png';
      if (window.plus && plus.nativeObj && plus.gallery) {
        const reader = new FileReader();
        reader.onload = () => {
          const bitmap = new plus.nativeObj.Bitmap('payqr');
          bitmap.loadBase64Data(reader.result, () => {
            const path = `_doc/pay-qrcode-${Date.now()}.png`;
            bitmap.save(path, { overwrite: true }, () => {
              plus.gallery.save(path, () => {
                bitmap.clear();
                this.$parent.showTost(1, '已保存到相册');
              }, () => {
                bitmap.clear();
                this.downloadQrFile(blob, filename);
              });
            }, () => {
              bitmap.clear();
              this.downloadQrFile(blob, filename);
            });
          }, () => this.downloadQrFile(blob, filename));
        };
        reader.onerror = () => this.downloadQrFile(blob, filename);
        reader.readAsDataURL(blob);
        return;
      }
      this.downloadQrFile(blob, filename);
    },
    downloadQrFile(blob, filename) {
      const file = new Blob([blob], { type: 'application/octet-stream' });
      const objectUrl = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1500);
      this.$parent.showTost(1, '二维码已保存到手机');
    },
    formatKbzPhone(phone) {
      let digits = String(phone || '').replace(/\D/g, '');
      if (digits.indexOf('95') === 0 && digits.length > 10 && digits.charAt(2) === '0') {
        digits = digits.slice(2);
      }
      return digits;
    },
    onBillFocus() {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      this.$nextTick(() => {
        window.scrollTo(0, scrollY);
        setTimeout(() => window.scrollTo(0, scrollY), 50);
      });
    },
    formatNow() {
      const d = new Date();
      const pad = n => (n >= 10 ? String(n) : `0${n}`);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    initKbzPending(query) {
      let payload = {};
      try {
        payload = JSON.parse(sessionStorage.getItem('kbz_deposit') || '{}') || {};
      } catch (e) {
        payload = {};
      }
      this.isKbzPending = true;
      this.kbzMethodId = query.method_id || payload.method_id || '';
      this.kbzAmount = query.amount || payload.amount || '';
      this.kbzPhone = this.formatKbzPhone(query.phone || payload.phone);
      this.kbzName = query.name || payload.name || 'KBZPay';
      this.payInfo = {
        deposit_no: '',
        info: {
          amount: this.kbzAmount,
          created_at: this.formatNow(),
          paytype: 'KBZPay',
        },
        cardlist: {
          phone: this.kbzPhone,
          content: this.kbzName,
        },
      };
      this.type = 'kbzpay';
      this.countTime();
    },
    completeKbzTransfer() {
      if (!this.canCompleteKbz || this.submitting) {
        return;
      }
      const last4 = String(this.billLast4 || '').replace(/\D/g, '');
      if (!/^\d{4}$/.test(last4)) {
        this.$parent.showTost(0, '请填写账单后四位数字');
        return;
      }
      if (!this.kbzMethodId || !this.kbzAmount) {
        this.$parent.showTost(0, '充值信息丢失，请重新发起');
        return;
      }
      this.submitting = true;
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/recharge', {
          paytype: 'code_pay',
          method_id: this.kbzMethodId,
          amount: Number(this.kbzAmount),
          bill_last4: last4,
        })
        .then(res => {
          this.submitting = false;
          this.$parent.hideLoading();
          if (res.code != 200) {
            this.$parent.showTost(0, res.message || '提交失败');
            return;
          }
          try {
            sessionStorage.removeItem('kbz_deposit');
          } catch (e) {}
          this.$parent.showTost(1, '已提交审核');
          this.$parent.goNav('/transRecord');
        })
        .catch(() => {
          this.submitting = false;
          this.$parent.hideLoading();
        });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    getpayinfo(deposit_no) {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.type = res.message;
          that.countTime();
        }
        this.$parent.hideLoading();
      });
    },
    countTime() {
      //获取当前时间
      let that = this;
      var date = new Date();
      var now = date.getTime(); //当前时间
      //   创建时间
      let created_at = that.payInfo.info.created_at;
      let createdTime = new Date(created_at).getTime();
      //设置截止时间
      var end = createdTime + 1000 * 60 * 60;
      //时间差
      var leftTime = end - now;

      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // that.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
      } else {
        // $('.time').html('00:00');
        clearInterval(that.countTime);
        that.countTime = null;

        return;
      }
      let m = that.m >= 10 ? that.m : `0${that.m}`;
      let s = that.s >= 10 ? that.s : `0${that.s}`;
      // $('.time').html(`${m}:${s}`);
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.countTime, 1000);
    },
  },
  computed: {
    kbzDisplayPhone() {
      const card = this.payInfo && this.payInfo.cardlist;
      return this.formatKbzPhone(this.kbzPhone || (card && card.phone) || (card && card.bank_no));
    },
    kbzDisplayName() {
      const card = this.payInfo && this.payInfo.cardlist;
      return this.kbzName || (card && (card.content || card.bank_owner)) || 'KBZPay';
    },
    canCompleteKbz() {
      return /^\d{4}$/.test(String(this.billLast4 || '').replace(/\D/g, '')) && !this.submitting;
    },
    qrUrl() {
      if (this.type === 'bankpay' || this.type === 'kbzpay' || this.isKbzPending) return '';
      const card = this.payInfo && this.payInfo.cardlist;
      return card && card.payimg ? card.payimg : '';
    },
  },
  watch: {
    billLast4(val) {
      const digits = String(val || '').replace(/\D/g, '').slice(0, 4);
      if (digits !== val) {
        this.billLast4 = digits;
      }
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.countTime) {
      clearInterval(that.countTime);
    }
    that.countTime = null;
  },
};
</script>
<style lang="scss" scoped>
@import '../../static/css/fund-recharge-info.dba269b9.css';

.pay-qr {
  width: 80%;
  display: block;
  margin: 10px auto;
}

.save-qr-btn {
  display: block;
  width: 80%;
  margin: 0 auto 16px;
  height: 40px;
  border: none;
  border-radius: 20px;
  background: #069b71;
  color: #fff;
  font-size: 15px;
}

.copy-strong {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  height: 30px;
  padding: 0 12px;
  margin-left: 8px;
  border-radius: 15px;
  background: #069b71;
  color: #fff !important;
  font-size: 15px;
  font-weight: 600;
  line-height: 30px;
}

.kbz-complete {
  margin: 8px 0 16px;
  padding-bottom: 80px;
}

.bill-last4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0 18px;
  font-size: 15px;
}

.bill-last4 input {
  width: 180px;
  height: 40px;
  border: 1px solid #d7d5d5;
  border-radius: 8px;
  padding: 0 10px;
  text-align: center;
  letter-spacing: 2px;
  font-size: 16px;
  transform: translateZ(0);
}

.complete-transfer-btn {
  display: block;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: #069b71;
  color: #fff;
  font-size: 16px;
}

.complete-transfer-btn:disabled {
  background: #ccc;
}
</style>

<style>
.pay-info-page .nav-header {
  background: #fff !important;
  background-image: none !important;
}

.pay-info-page .van-nav-bar__title {
  color: #222 !important;
}

.pay-info-page .pay-back {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #222;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pay-info-page .pay-back .van-nav-bar__arrow,
.pay-info-page .pay-back .van-icon-arrow-left {
  color: #fff !important;
  font-size: 20px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue